

define(['squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-models/src/fi/index', 'components/xo-ui-components/src/message/directive', 'components/xo-ui-components/src/error-tooltip/directive'], function (squid, template) {

    return squid.module('xo-add-bank.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xo-message.directive', 'xo-error-tooltip.directive', 'fi.errorUtil']).directive('xoAddBankFlow', function () {
        return {
            template: template,

            scope: {
                token: '=',
                parentCallbacks: '=',
                sidebar: '=',
                hideparenthead: '=',
                pageLevel: '='
            },

            controller: function controller($scope, $rootScope, $AddBankModel, $CheckoutCartModel, $populate, $CheckoutSessionModel, $state, $locale, $element, $fiErrorUtil) {

                function handleContingency(name, result) {

                    $scope.errorMessage = $fiErrorUtil.addPageErrors(result, 'bank');
                    $fiErrorUtil.addFieldErrors(result, $element, 'model.');
                    $state.go('^.add');
                }

                function updateFundingOptions() {
                    $scope.checkoutSession.fundingOptions.action('update', {

                        resultModel: $scope.checkoutSession,

                        data: {
                            planId: $scope.bankId
                        },
                        success: function success(result) {

                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['paymentMethod.paymentMethodUpdated']
                            };
                            $scope.parentCallbacks.done();
                        },
                        contingencies: {
                            ADD_BANK_CONTINGENCY: handleContingency
                        }

                    });
                }

                $scope.callbacks = {

                    addBankDone: function addBankDone(bank) {
                        $scope.bank = bank;
                        $state.go('^.sepa');
                    },

                    sepaDone: function sepaDone() {

                        $populate($scope, {
                            checkoutSession: $CheckoutSessionModel.instance($scope.token),
                            cart: $CheckoutCartModel.instance($scope.token)
                        }).then(function () {

                            $scope.locale = $locale;

                            var addBankReq = $scope.bank.getBankData();
                            $scope.bank.action('add', {

                                data: addBankReq,

                                resultModel: {},

                                success: function success(data) {

                                    $scope.bankId = data.id;
                                    var sepaStatus = data.sepaStatus;
                                    if (sepaStatus === 'AUTHORIZED') {
                                        return updateFundingOptions();
                                    }
                                    $scope.bank.action('sepaAccept', {

                                        data: {
                                            bank: {
                                                id: data.id
                                            }
                                        },

                                        resultModel: {},

                                        success: updateFundingOptions,
                                        contingencies: {
                                            DEFAULT: handleContingency
                                        }

                                    });
                                },

                                contingencies: {
                                    ADD_BANK_CONTINGENCY: handleContingency
                                }

                            });
                        });
                    }

                };
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/add-bank/directive.js
// module id = ./components/xo-wallet-components/src/add-bank/directive.js
// module chunks = 1